import React, { useTransition } from 'react';
import { Trans, useTranslation } from 'react-i18next';

const scrollTo = (ref) => {
    if (!ref) {
        return;
    } 

    const hash = '#' + ref.id;

    if (hash === window.location.hash) {
        ref.scrollIntoView();
    }
}

const DnpHelp = () => {
    const { t } = useTranslation(['help']);

    return (
        <div>
            <h2 id="konfiguration-basmodul">{t('configureBaseModule.title', { ns: 'help' })}</h2>
            <h3 id="aktiv">{t('configureBaseModule.active.title', { ns: 'help' })}</h3>
            <p>{t('configureBaseModule.active.text1', { ns: 'help' })}</p>
            <h3 id="dryrun">{t('configureBaseModule.dryRun.title', { ns: 'help' })}</h3>
            <p>{t('configureBaseModule.dryRun.text1', { ns: 'help' })}</p>
            <h3 id="titel">{t('configureBaseModule.titleField.title', { ns: 'help' })}</h3>
            <p>{t('configureBaseModule.titleField.text1', { ns: 'help' })}</p>
            <h3 id="schemalaggning">{t('configureBaseModule.schedule.title', { ns: 'help' })}</h3>
            <p>{t('configureBaseModule.schedule.text1', { ns: 'help' })}</p>
            <h4 id="tidsbaserad-schemal-ggning">{t('configureBaseModule.schedule.timebased.title', { ns: 'help' })}</h4>
            <p><Trans i18nKey='configureBaseModule.schedule.timebased.text1' ns='help' values={{ url: 'https://crontab.guru/' }} components={{ lnkCron: <a href="https://crontab.guru/">https://crontab.guru/</a> }}/></p>
            <p>{t('configureBaseModule.schedule.timebased.text2', { ns: 'help' })}</p>
            <p>{t('configureBaseModule.schedule.timebased.text3', { ns: 'help' })}</p>
            <h4 id="modulbaserat-schemal-ggning">{t('configureBaseModule.schedule.modulebased.title', { ns: 'help' })}</h4>
            <p>{t('configureBaseModule.schedule.modulebased.text1', { ns: 'help' })}</p>
            <p>{t('configureBaseModule.schedule.modulebased.text2', { ns: 'help' })}</p>
            <h2 id="konfiguration-digitala-nationella-prov" ref={scrollTo} className="help-scrollable">{t('dnpHelp.title', { ns: 'help' })}</h2>
            <h3 id="organisationnummer">{t('dnpHelp.orgnr.title', { ns: 'help' })}</h3>
            <p>{t('dnpHelp.orgnr.text1', { ns: 'help' })}</p>
            <p>{t('dnpHelp.orgnr.text2', { ns: 'help' })}</p>
            <h3 id="malmiljo">{t('dnpHelp.targetEnv.title', { ns: 'help' })}</h3>
            <p>{t('dnpHelp.targetEnv.text1', { ns: 'help' })}</p>
            <h3 id="koppla-skolenheter">{t('dnpHelp.schoolMapping.title', { ns: 'help' })}</h3>
            <p>{t('dnpHelp.schoolMapping.text1', { ns: 'help' })}</p>
            <p>{t('dnpHelp.schoolMapping.text2', { ns: 'help' })}</p>
            <h3 id="metadata-for-moa" ref={scrollTo} className="help-scrollable">{t('dnpHelp.moaMetadata.title', { ns: 'help' })}</h3>
            <p>{t('dnpHelp.moaMetadata.text1', { ns: 'help' })}</p>
            <h2 id="aktivitetskoppling" ref={scrollTo} className="help-scrollable">{t('dnpHelp.activityMapping.title', { ns: 'help' })}</h2>
            <p>{t('dnpHelp.activityMapping.text1', { ns: 'help' })}</p>
            <p>{t('dnpHelp.activityMapping.text2', { ns: 'help' })}</p>
            <h3 id="filter">{t('dnpHelp.activityMapping.filter.title', { ns: 'help' })}</h3>
            <p>{t('dnpHelp.activityMapping.filter.text1', { ns: 'help' })}</p>
            <h4 id="flowsync">{t('dnpHelp.activityMapping.filter.flowSync.title', { ns: 'help' })}</h4>
            <p>{t('dnpHelp.activityMapping.filter.flowSync.text1', { ns: 'help' })}</p>
            <ul>
                <li>{t('dnpHelp.activityMapping.filter.flowSync.options.search', { ns: 'help' })}</li>
                <li>{t('dnpHelp.activityMapping.filter.flowSync.options.subject', { ns: 'help' })}</li>
                <li>{t('dnpHelp.activityMapping.filter.flowSync.options.course', { ns: 'help' })}</li>
                <li>{t('dnpHelp.activityMapping.filter.flowSync.options.school', { ns: 'help' })}</li>
            </ul>
            <h4 id="skolverket">{t('dnpHelp.activityMapping.filter.skolverket.title', { ns: 'help' })}</h4>
            <ul>
                <li>{t('dnpHelp.activityMapping.filter.skolverket.options.schoolType', { ns: 'help' })}</li>
                <li>{t('dnpHelp.activityMapping.filter.skolverket.options.schoolYear', { ns: 'help' })}</li>
            </ul>
            <h3 id="kopplade-aktiviteter">{t('dnpHelp.activityMapping.mappedActivities.title', { ns: 'help' })}</h3>
            <p>{t('dnpHelp.activityMapping.mappedActivities.text1', { ns: 'help' })}</p>
            <h3 id="ej-kopplade-aktiviteter">{t('dnpHelp.activityMapping.notMappedActivities.title', { ns: 'help' })}</h3>
            <p>{t('dnpHelp.activityMapping.notMappedActivities.text1', { ns: 'help' })}</p>
            <h3 id="felaktigt-kopplade-aktiviteter">{t('dnpHelp.activityMapping.erroneouslyMappedActivities.title', { ns: 'help' })}</h3>
            <p>{t('dnpHelp.activityMapping.erroneouslyMappedActivities.text1', { ns: 'help' })}</p>
            <p>{t('dnpHelp.activityMapping.erroneouslyMappedActivities.text2', { ns: 'help' })}</p>
            <h2 id="faq">{t('dnpHelp.faq.title', { ns: 'help' })}</h2>
            <h3 id="hur-hanteras-elever-som-tillhor-en-annan-arskurs-an-den-for-provaktiviteten-gallande-arskursen">{t('dnpHelp.faq.item1.question', { ns: 'help' })}</h3>
            <p>{t('dnpHelp.faq.item1.answer', { ns: 'help' })}</p>
        </div>
    )
}

export default DnpHelp;
